module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "140px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name",
      "rules": [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur',
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "num",
      "rules": [{
        required: true,
        validator: _vm.validator.idCard,
        message: '请输入身份证号',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位全称",
      "prop": "danwei",
      "rules": [{
        required: true,
        message: '单位名称不能为空',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属地区",
      "prop": "area",
      "rules": [{
        required: true,
        message: '点击选择省市区',
      } ]
    }
  }, [_c('el-cascader', {
    ref: "areas",
    attrs: {
      "options": _vm.areaOptions,
      "props": {
        label: 'title'
      }
    },
    on: {
      "change": _vm.handleAreasChange
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.sex),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sex", $$v)
      },
      expression: "formData.sex"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "男"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "女"
    }
  }, [_vm._v("女")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "民族",
      "prop": "minzu",
      "rules": []
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入民族"
    },
    model: {
      value: (_vm.formData.minzu),
      callback: function($$v) {
        _vm.$set(_vm.formData, "minzu", $$v)
      },
      expression: "formData.minzu"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "个人证件照",
      "prop": "zhengjianimg"
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.zhengjianimg,
      "limit": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("近期个人2寸免冠相片")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机",
      "prop": "phone",
      "rules": [{
        required: true,
        validator: _vm.validator.phone,
        message: '请输入正确的手机号',
        trigger: ['blur', 'change'],
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入正确的手机号"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email",
      "rules": [{
        required: true,
        validator: _vm.validator.email,
        message: '请输入正确的邮箱',
        trigger: ['blur', 'change'],
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通级比赛时间",
      "prop": "bisaidate"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入通级比赛时间"
    },
    model: {
      value: (_vm.formData.bisaidate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "bisaidate", $$v)
      },
      expression: "formData.bisaidate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通级比赛地点",
      "prop": "bisaididian"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入通级比赛地点"
    },
    model: {
      value: (_vm.formData.bisaididian),
      callback: function($$v) {
        _vm.$set(_vm.formData, "bisaididian", $$v)
      },
      expression: "formData.bisaididian"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通级比赛名次",
      "prop": "bisaichengji"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入通级比赛名次"
    },
    model: {
      value: (_vm.formData.bisaichengji),
      callback: function($$v) {
        _vm.$set(_vm.formData, "bisaichengji", $$v)
      },
      expression: "formData.bisaichengji"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "个人能力测试时间",
      "prop": "chengjidate"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入个人能力测试时间"
    },
    model: {
      value: (_vm.formData.chengjidate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "chengjidate", $$v)
      },
      expression: "formData.chengjidate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "个人能力测试地点",
      "prop": "chengjididian"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入个人能力测试地点"
    },
    model: {
      value: (_vm.formData.chengjididian),
      callback: function($$v) {
        _vm.$set(_vm.formData, "chengjididian", $$v)
      },
      expression: "formData.chengjididian"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "个人能力测试成绩",
      "prop": "chengji"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入个人能力测试成绩"
    },
    model: {
      value: (_vm.formData.chengji),
      callback: function($$v) {
        _vm.$set(_vm.formData, "chengji", $$v)
      },
      expression: "formData.chengji"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "已有技术等级",
      "prop": "oldgrade"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.oldgrade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "oldgrade", $$v)
      },
      expression: "formData.oldgrade"
    }
  }, _vm._l((_vm.oldGradeColumns), function(item) {
    return _c('el-radio', {
      key: item,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "已有项目",
      "prop": "oldproject"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.oldproject),
      callback: function($$v) {
        _vm.$set(_vm.formData, "oldproject", $$v)
      },
      expression: "formData.oldproject"
    }
  }, _vm._l((_vm.oldProjectColumns), function(item) {
    return _c('el-radio', {
      key: item,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现报技术等级",
      "prop": "grade"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }, _vm._l((_vm.gradeColumns), function(item) {
    return _c('el-radio', {
      key: item,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现报项目",
      "prop": "grade"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.project),
      callback: function($$v) {
        _vm.$set(_vm.formData, "project", $$v)
      },
      expression: "formData.project"
    }
  }, _vm._l((_vm.projectColumns), function(item) {
    return _c('el-radio', {
      key: item,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "近三年啦啦操参赛成绩",
      "prop": "jianli"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "从事啦啦操运动简历和主要运动成绩..."
    },
    model: {
      value: (_vm.formData.jianli),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jianli", $$v)
      },
      expression: "formData.jianli"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证照片",
      "prop": "pic"
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("上传身份证正面、背面照片")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传相关证明材料",
      "prop": "attsrc"
    }
  }, [_c('FileUploader', {
    attrs: {
      "fileList": _vm.formData.attsrc,
      "limit": 1,
      "accept": ".rar,.zip"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("有效成绩证明，比赛成绩册、秩序册或获奖证书的复印件，请先打包成单个rar或zip格式的文件，然后上传")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('YundongyuanPicker', {
    attrs: {
      "show": _vm.showYundongyuanPicker,
      "limit": 30,
      "defaultValue": _vm.formData.yundongyuan
    },
    on: {
      "onChange": _vm.onYundongyuanChange,
      "onClose": function($event) {
        _vm.showYundongyuanPicker = false
      },
      "onConfirm": _vm.onYundongyuanConfirm
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38d0615f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/LevelApplyMemberAdd.vue
// module id = 1379
// module chunks = 0